<script>
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import {usePaySlipStore} from "@/stores/PaySlip";
import {onMounted, ref} from "vue";
import PaySlipPage from "../PaySlipPage.vue";
import axios from "axios";

export default {
    computed: {
        paySlip() {
            return PaySlipPage
        }
    },
    setup() {
        const {$route} = useTools();
        const {dialog, loading, overlay} = useSharedData();
        const {getBack} = useSharedMethod();
        const paySlipStore = usePaySlipStore();

        const paySlip = ref({});

        function findById(id) {
            loading.value = true;
            axios.get(`/payments/${id}`).then(response => {
                paySlip.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }


        function remove() {
            loading.value = true;
            axios.delete(`/payments/${$route.params.id}`).then(() => {
                paySlipStore.setRefresh();
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => findById($route.params.id));

        return {
            dialog,
            loading,
            overlay,
            paySlip,
            remove,
            getBack
        }
    }
};
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="600"
    >
        <v-card flat>
            <w-overlay
                :loading="loading"
                :overlay="overlay"
                delete-action
                @cancel="overlay = false"
                @remove="remove"
            ></w-overlay>
            <w-toolbar color="red" :title="$t('common.delete')"/>
            <v-card-text>
                <v-row align="center" justify="center" style="height: 200px;">
                    <h2 class="text-center">
                        {{ $t('pay_slip.ask_for_remove') }}
                        <span class="red--text">{{ `${paySlip.workerLastName} ${paySlip.workerFirstName}` }}</span>
                    </h2>
                </v-row>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-delete
                    show
                    :loading="loading"
                    @press="overlay = true"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>